import React, { Component, Fragment } from 'react';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../../store/actions/notificationAction';

import poRequestHandler from '../../../api/pickupOrderRemote';

import TrkPickupOrder from './TrkPickupOrder';
import DockerOverloadModalContainer from '../../dockOverloadModal/DockerOverloadModalContainer';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import PickupOrderModel from '../../../models/PickupOrder';

import { PO_SCHEMA } from '../../../utils/pickupOrder';


interface MatchParams {
  po: string;
  key: string;
};

interface trkPickupOrderProps extends RouteComponentProps<MatchParams>{
  receiveError: Function;
  receiveSuccess: Function;
};

interface trkPickupOrderState {
  pickupOrder: PickupOrderModel;
  openDockOverloadModal: boolean;
};

class TrkPickupOrderContainer extends Component<trkPickupOrderProps, trkPickupOrderState> {

  state = {
    pickupOrder: PO_SCHEMA,
    openDockOverloadModal: false,
  }

  componentDidMount() {

    const params: MatchParams = this.props.match.params;

    poRequestHandler.getPickupOrder(params.po, params.key).then((resp: ApiResponse<PickupOrderModel>) => {

      const po: PickupOrderModel | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (po) {
        // keep the initial values to '' instead of nulls because react throws a warning for uncontrolled components 
        po.additional_info = po.additional_info || '';
        po.trucker_info = po.trucker_info || '';
        po.driver_name = po.driver_name || '';
        po.driver_id = po.driver_id || '';
        po.driver_id_type = po.driver_id_type || 'CDL';
        po.driver_vehichle_registration = po.driver_vehichle_registration || '';


        po.allowed_ops =  po.allowed_ops || {
          update_date: true,
          update_awb_address: true,
          update_dispatch_driver_details: true,
          driver_checked_in: true,
          update_wh_locations: true,
          set_dock: true,
          update_exception_and_notes: true,
          update_customs_clearance: true,
        }
        this.setState({ pickupOrder: po });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleChange = (fieldName: string, event: any): void => {

    const currentPO: PickupOrderModel = { ...this.state.pickupOrder };
    const value: string = event.target.value;

    switch (fieldName) {
      case 'truckerInformation': 
        currentPO.trucker_info = value; 
        break;
      case 'driverName':
        currentPO.driver_name = value;
        break;
      case 'driverId':
        currentPO.driver_id = value;
        break;
      case 'driverIdType':
        currentPO.driver_id_type = value;
        break;
      case 'driverVehichleRegistration':
        currentPO.driver_vehichle_registration = value;
        break;
      default: break;
    }

    this.setState({ pickupOrder: currentPO });
  }

  handleSave = (): void => {

    const params: MatchParams = this.props.match.params;

    poRequestHandler.saveDriverInfo(params.po, params.key, this.state.pickupOrder).then((resp: ApiResponse<boolean>) => {
      
      const po: any = resp.result;
      if (po) {
        this.props.receiveSuccess('The PO has been successfully updated!');
      }

      const error: ResponseError | undefined = resp.error;
      
      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleCloseDockOverloadModal = (time: string): void => {

    if (time) {

      const setTime: string = time.replace('.','');
      const currentPO: PickupOrderModel = { ...this.state.pickupOrder };
      
      currentPO.pickup_time = setTime;
      this.setState({ pickupOrder: currentPO });
    };
    this.setState({ openDockOverloadModal: false });
  };

  handleSelectPickUpTime = (): void => {
    this.setState({ openDockOverloadModal: true });
  }

  render() {
    return (
      <Fragment>
        <TrkPickupOrder
          pickupOrder={ this.state.pickupOrder}
          secretKey={this.props.match.params.key}
          handleChange={ this.handleChange }
          handleSave={ this.handleSave }
          handleSelectPickUpTime={ this.handleSelectPickUpTime }
        />
        { this.state.openDockOverloadModal &&
          <DockerOverloadModalContainer 
            openDockOverloadModal={ this.state.openDockOverloadModal }
            handleCloseDockOverloadModal={ this.handleCloseDockOverloadModal }
            ghaID={ this.state.pickupOrder.id_gha }
            type={ 'import' }
            forInfo={ false }
            date={ this.state.pickupOrder.pickup_date }
            time={ this.state.pickupOrder.pickup_time }
            secretKey={ this.props.match.params.key }
          />
        }
      </Fragment>
    );
  };
};


const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess:(message: string) => dispatch(receiveSuccess(message))
  };
};

export default connect(null, mapDispatchToProps)(TrkPickupOrderContainer);